import { render, staticRenderFns } from "./contactar.vue?vue&type=template&id=75dfa56a&scoped=true&"
import script from "./contactar.vue?vue&type=script&lang=js&"
export * from "./contactar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfa56a",
  null
  
)

export default component.exports